// Client-side affiliate click tracking.
//
// Fired from every outbound marketplace link on the price board and card pages.
// It must never block or swallow the navigation, so it uses sendBeacon: a normal
// fetch is cancelled the moment the browser leaves for eBay, which is exactly
// when the click matters.

const ENDPOINT = "/api/public/affiliate-click";

export interface ClickMeta {
  /** Price source id, e.g. "ebay", "tcgplayer", "ebay-graded". */
  source: string;
  /** What was clicked: "card", "sealed" or "merch". */
  kind: "card" | "sealed" | "merch";
  /** Card code or sealed product key. */
  targetKey: string;
}

export function trackAffiliateClick(meta: ClickMeta): void {
  if (typeof window === "undefined") return;
  const payload = JSON.stringify({
    source: meta.source,
    kind: meta.kind,
    targetKey: meta.targetKey,
    page: window.location.pathname,
    signedIn: document.cookie.includes("sb-") || Boolean(window.localStorage.getItem("sb-auth-present")),
  });
  try {
    const blob = new Blob([payload], { type: "application/json" });
    if (navigator.sendBeacon?.(ENDPOINT, blob)) return;
    void fetch(ENDPOINT, { method: "POST", body: payload, headers: { "Content-Type": "application/json" }, keepalive: true }).catch(
      () => {},
    );
  } catch {
    /* tracking must never break a click */
  }
}
